export enum CloudItemType {
  Unknown = "unknown",
  File = "file",
  Folder = "folder",
}
